import ShareableLinkHasExpired from './ShareableLinkHasExpired.component';

export default ShareableLinkHasExpired;
